import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { formatMoney, getTagValue, getFurnitureImage } from '../../functions';
import { addItem, updateItem } from '../../redux/cart/actions';
import IconMinus from '../icons/IconMinus';
import IconPlus from '../icons/IconPlus';

const CartItem = (props) => {
  const { item, isLoading, updateItem } = props;
  const title = item.type === 'Furniture' ? `${getTagValue(item.tags, 'range')} ${getTagValue(item.tags, 'size')} ${item.title}` : item.title;
  const imgSrc = item.type === 'Furniture' && item.properties && item.properties.length
    ? getFurnitureImage(item.title, item.properties.map((property) => ({
      color: property[1].split('-')[1].trim(),
      material: property[1].split('-')[0].trim(),
    })), '660x')
    : item.image;

  const measurementSystem = window.getMeasurementSystem();
  const measurements = item.measurements[measurementSystem];
  const replaceSize = (sizeStr) => {
    let newInfo = sizeStr;
    if (measurements && measurements.includes(':')) {
      let isTitleReplaced = false;

      measurements
        .split(',')
        .forEach((measurementItem) => {
          if (isTitleReplaced) return;

          const keyValuePair = measurementItem.split(':');
          if (keyValuePair[1] && keyValuePair[1].toLowerCase() !== 'null' && keyValuePair[1].toLowerCase() !== 'n/a' && keyValuePair[0] !== keyValuePair[1]) {
            if (keyValuePair[0].includes(' x ')) {
              newInfo = newInfo.replaceAll(keyValuePair[0], keyValuePair[1]);
            } else {
              newInfo = newInfo.replaceAll(keyValuePair[0], measurementItem.replace(':', ' '));
            }

            if (newInfo !== sizeStr) {
              isTitleReplaced = true;
            }
          }
        });
    } else {
      // Replace 'size' option value
      newInfo = measurements;
    }
    return newInfo;
  };

  let shippingNote = '';
  if (item.shipping) {
    if (typeof item.shipping === 'string') {
      shippingNote = (<p className="mt-2 color-subtle">{item.shipping}</p>);
    } else if (Array.isArray(item.shipping)) {
      shippingNote = item.shipping.map((shippingNoteItem, index) => (
        <p
          className="mt-2 color-subtle"
          data-countries-show={shippingNoteItem.countries}
          key={`ShippingNote-${index}`}
        >
          {shippingNoteItem.message}
        </p>
      ));
    }
  }

  return (
    <tr className="cart__item">
      <td className="cart__td cart__image cart__item-image">
        <a className="cart__item-img-wrapper" href={item.type === 'giftnote_giftcard' ? '/pages/e-gift-card' : item.url}>
          <div className="embed-responsive">
            <img className="cart__item-img bg-grey embed-responsive-item" src={imgSrc} sizes="318px" alt={title} />
          </div>
        </a>
      </td>
      <td className="cart__td cart__info cart__item-info">
        <h3 className="p mb-2"><a href={item.type === 'giftnote_giftcard' ? '/pages/e-gift-card' : item.url} className="unstyled-link">{title}</a></h3>
        {item.optionsWithValues && item.optionsWithValues.length
          && item.optionsWithValues.map((option, index) => {
            const color = item.properties && item.properties.length && index > 1
              ? item.properties.find((property) => property[0] === option.name)[1] : null;
            return (
              <p className="color-subtle cart__property" key={option.name}>
                <span className="cart__option">{option.name}</span>
                <span>
                  {
										option.name.toLowerCase() === 'size'
										  ? replaceSize(option.value)
										  : color
										    ? color.replace('-', '/')
										    : option.value
									}
                </span>
              </p>
            );
          })}
        {item.type !== 'Furniture'
          && item.properties
          && item.optionsWithValues && item.optionsWithValues.length
          && item.properties.map((property, index) => (
            <p className={index === (item.properties.length - 1) ? 'color-subtle cart__property mb-2' : `color-subtle cart__property${property[0].includes('__') ? ' property-giftnote' : ''}`} key={property[0]}>
              <span className="cart__option">
                {item.type === 'giftnote_giftcard'
                  ? property[0].replace('__', '').replace('giftcard_', '').charAt(0).toUpperCase()
                  + property[0].replace('__', '').replace('giftcard_', '').substring(1)
                  : property[0]}
              </span>
              <span>{property[1].replace('-', '/')}</span>
            </p>
          ))}
        {shippingNote}
        {!item.optionsWithValues && item.variantName && (<p className="mb-0 color-subtle">{item.variantName}</p>)}
        {item.error && (<p className="mb-0 error">{item.error}</p>)}
        <button
          onClick={() => props.updateItem(item.variantId, 0)}
          disabled={isLoading}
          className="cart__remove-button button-text-only"
          type="button"
        >
          Remove
        </button>
      </td>
      <td className="cart__td cart__quantity cart__item-quantity">
        <span className="p">
          {item.quantity}
            &nbsp;
        </span>
        <button
          onClick={() => updateItem(item.variantId, (item.quantity - 1))}
          disabled={isLoading}
          className={item.type === 'giftnote_giftcard' || item.type === 'Gift Cards' ? 'd-none' : 'cart__qty-button'}
          type="button"
        >
          <IconMinus />
        </button>
        <button
          onClick={() => updateItem(item.variantId, (Number(item.quantity) + 1))}
          disabled={isLoading}
          className={item.type === 'giftnote_giftcard' || item.type === 'Gift Cards' ? 'd-none' : 'cart__qty-button'}
          type="button"
        >
          <IconPlus />
        </button>
      </td>
      <td className="cart__td cart__price cart__item-price">
        <p className="cart-rhs__price">
        {Shopify.currency.active + " " + formatMoney(item.itemPriceCents * item.quantity)}
        </p>
      </td>
    </tr>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.cart.isLoading,
});

const mapDispatchToProps = {
  addItem,
  updateItem,
};

CartItem.propTypes = {
  item: PropTypes.shape({
    optionsWithValues: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })),
    key: PropTypes.string,
    url: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.string),
    type: PropTypes.string,
    variantName: PropTypes.string,
    variantId: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    properties: PropTypes.arrayOf(PropTypes.array),
    image: PropTypes.string,
    imgSrcset: PropTypes.string,
    info: PropTypes.string,
    itemPriceCents: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    error: PropTypes.string,
    shipping: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.any),
    ]),
    measurements: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.objectOf(PropTypes.any),
    ]),
  }).isRequired,
  updateItem: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CartItem);
